export function getStyleUnit(value) {
  return `${value}`.match(/\d+$/) ? `${value}px` : value
}

export function clearFix() {
  return `
    &:after {
      display: table;
      content: '';
      clear: both;
    }
  `
}



// WEBPACK FOOTER //
// ./src/components/styles/helpers.js